var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { fill: "currentColor", stroke: "none", strokeWidth: 1, fillRule: "evenodd" },
            React.createElement("path", { d: "M23 20.073V35a1 1 0 01-1 1H10.981a1 1 0 01-.804-1.594L21.195 19.48a1 1 0 011.805.594zM25.406 19.269a1 1 0 011.318.114l.08.096 11.02 14.927a1 1 0 01-.689 1.587L37.02 36H26a1 1 0 01-.993-.883L25 35V20.073a1 1 0 01.406-.804zm2.087 5.21v9.055h6.548l-6.548-9.054zM31.615 11.406c-.026-.335-.431-.472-.675-.229l-2.052 2.052-.504-.494c-2.972-2.97-7.916-2.862-11.022.244l-.185.188-.336.351-.29.321-.247.294c-.904 1.122-.821 1.631-.365 2.141l.122.128c.636.636 1.357.145 1.98-.496l.202-.218.632-.734.151-.168.07-.073c2.107-2.106 5.46-2.18 7.475-.165l.496.503-2.054 2.053c-.243.244-.106.65.229.675l6.422.495a.42.42 0 00.446-.446l-.495-6.422z" }))));
});
